import type { PropsWithChildren, JSX } from 'react';
import { useAuthenticated } from './session-hooks';

type IfAuthenticatedProps = {
  notAuthenticated?: JSX.Element | null;
};

export const IfAuthenticated = ({ children, notAuthenticated = null }: PropsWithChildren<IfAuthenticatedProps>) => {
  const isAuthenticated = useAuthenticated();

  if (!isAuthenticated) {
    return notAuthenticated;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

